module.exports = __webpack_public_path__ + "resource/img/image029.3a18b8d3.png";